import React, { lazy, Suspense, useEffect } from 'react';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import TableSkeleton from '../../../components/TableSkeleton';
import Spinner from '../../../components/Spinner';
import FiltersSkeleton from '../../../components/FiltersSkeleton';
import { useUsers } from '../../../contexts/UserContext';
import { PlusIcon } from '@heroicons/react/24/solid';
import { Button } from '../../../components/ui/button';
import { useNavigate } from 'react-router-dom';

const Filters = lazy(() => import('./Filters'));
const TanstackTable = lazy(() => import('../../../components/TanstackTable'));
const ConfirmDialog = lazy(() => import('../../../components/ConfirmDialog'));

const Manage = () => {
    const navigate = useNavigate();
    
    const {
        table,
        columns,
        loading,
        users,
        pagination,
        handlePageChange,
        updateData,
        setOpenUpdateModal,
        showDeleteConfirmationDialog,
        handleCloseModal,
        handleDelete,
    } = useUsers();

    useEffect(() => {
        if (updateData.id !== "") { 
            setOpenUpdateModal(true);
        }
    }, [updateData, setOpenUpdateModal]);

    return (
        <>
            <Card className="w-full mb-2 overflow-hidden">
                <CardHeader>Users</CardHeader>
                <CardContent>
                    <div>
                        <div className="flex justify-between mb-4 hidden md:flex">
                            <Suspense fallback={<FiltersSkeleton/>}>
                                <Filters />
                            </Suspense>
                            <div className="flex items-start mb-4">
                                {/* <Suspense fallback={<Skeleton className="w-5 h-5"/>}>
                                    <TanstackColumns table={table} data={users} columns={columns} />
                                </Suspense> */}
                                <Suspense fallback={<Spinner container="h-8 w-[130px]"/>}>
                                    <Button onClick={() => navigate(`/users/add`)} variant="border_outline"> <PlusIcon className='w-4 h-4 mr-2' /> Add User</Button>
                                </Suspense>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 justify-between mb-4 md:hidden">
                            <Suspense fallback={<Spinner container="h-8 w-full"/>}>
                                <Button onClick={() => navigate(`/users/add`)} variant="border_outline"> <PlusIcon className='w-4 h-4 mr-2' /> Add User</Button>
                            </Suspense>
                            <Suspense fallback={<FiltersSkeleton/>}>
                                <Filters />
                            </Suspense>
                        </div>
                    </div>
                    <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Status", "Actions"]}/>}> 
                        <TanstackTable
                            loading={loading}
                            table={table}
                            data={users || []}
                            columns={columns}
                            pagination={pagination}
                            handlePageChange={handlePageChange}
                        />
                    </Suspense>
                </CardContent>
            </Card>
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this User?"
                />
            </Suspense>
        </>
    );
};

export default Manage;
